// TODO: Review new Spreqadsheet from Clay

//@ts-check
import { createContext } from "react";
export const Video = createContext(null);
